import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { browserCompatibility } from './services/BrowserCompatibility'

// Initialize browser compatibility checks
browserCompatibility.initialize().catch((error) => {
  console.error('Failed to initialize browser compatibility:', error);
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
